import React, { useContext, useState, useEffect, useMemo } from 'react';
import { fetchData } from '../service/data.service';

const YogaContext = React.createContext();

export const useYogaContext = () => useContext(YogaContext);

export function YogaProvider({ children }) {
  const [banner, setBanner] = useState({});
  const [experience, setExperience] = useState({});
  const [sharedApp, setSharedApp] = useState({});
  const [article, setArticle] = useState([]);
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    fetchData.get('https://run.mocky.io/v3/464009a3-4cc1-4c02-a00e-ca9e2525b399').then(setBanner);
    fetchData
      .get('https://run.mocky.io/v3/c6c01451-117a-49e2-bd0d-2b15e3efca86')
      .then(setExperience);
    fetchData
      .get('https://run.mocky.io/v3/1738781c-f579-4507-b55b-7094db9b778a')
      .then(setSharedApp);
    fetchData.get('https://run.mocky.io/v3/a3ef5b16-ae39-4448-bf7c-f015c433194a').then(setArticle);
    fetchData.get('https://run.mocky.io/v3/9ab0a1a3-0f85-49ad-9728-6b571aaf9f3b').then(setVideos);
  }, []);

  const value = useMemo(
    () => ({
      banner,
      experience,
      sharedApp,
      article,
      videos,
    }),
    [banner, experience, sharedApp, article, videos]
  );

  return <YogaContext.Provider value={value}>{children}</YogaContext.Provider>;
}
